import { FormsCustomTemplatesFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import FormsTemplatesDataCollection from 'modules/forms/components/FormsTemplatesDataCollection'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const SmartSurveysTemplatesPage = () => {
  const { navigation } = useNavigation()

  const itemUrl = (item: FormsCustomTemplatesFragment) => {
    return navigation.engagement.smart_surveys.templates.id.fullPath({ id: item.id })
  }

  return (
    <ResponsivePage.Body>
      <FormsTemplatesDataCollection
        resourceType="Surveys::Survey"
        itemUrl={itemUrl}
        routes={{
          create: navigation.engagement.smart_surveys.templates.new.fullPath(),
          edit: (id) => navigation.engagement.smart_surveys.templates.id.fullPath({ id }),
          use: (id) => `${navigation.engagement.smart_surveys.new.fullPath()}?templateId=${id}`,
        }}
      />
    </ResponsivePage.Body>
  )
}

export default SmartSurveysTemplatesPage
